import styled, { css } from 'styled-components';
import { DataListItemProps } from '.';

export const Container = styled.div<DataListItemProps>`
  display: flex;
  flex-direction: ${({ $orientation }) =>
    $orientation === 'vertical' ? 'column' : 'row'};

  flex: ${({ $orientation }) => ($orientation === 'vertical' ? 0 : 1)};
  justify-content: ${({ $orientation }) =>
    $orientation === 'vertical' ? 'left' : 'space-between'};

  ${({ theme, $size }) => {
    return css`
      font-size: ${theme.typography.font.size[$size]}px;
      font-family: var(--font-${theme.typography.font.family.text});
      font-weight: ${theme.typography.font.weight.bold};
      line-height: ${theme.typography.font.line_height[$size]}px;
    `;
  }}

  text-align: end;

  color: ${({ theme }) => theme.colors.neutral.neutral[12]};
`;

export const Label = styled.span<DataListItemProps>`
  ${({ theme, $size }) => {
    return css`
      font-size: ${theme.typography.font.size[$size]}px;
      font-family: var(--font-${theme.typography.font.family.text});
      font-weight: ${theme.typography.font.weight.medium};
      line-height: ${theme.typography.font.line_height[$size]}px;
      text-align: start;
    `;
  }}

  color: ${({ theme, $highContrast }) =>
    theme.colors.neutral[$highContrast ? 'neutral' : 'neutral_alpha'][
      $highContrast ? 12 : 11
    ]};
`;
